// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1lQmF","alertIcon":"ConfirmModal_alertIcon__1ImaI"};